

import React, { useEffect, useState } from "react";
import Services from "../services/services";

const SelectAPIKey = ({ className, selectedKey, onSelect }) => {
    const [apiKeys, setApiKeys] = useState([]);

    // Fetch API Keys
    const fetchAPIKeys = async () => {
        const res = await Services.APIKey.get();
        const data = await res.json();
        setApiKeys(data?.data || []);
    };

    useEffect(() => {
        fetchAPIKeys();
    }, []);


    return (
        <select className={`${className} border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-400`}
            value={selectedKey}
            onChange={(e) => onSelect(e.target.value)}>
            <option value="">Your keys</option>
            {(apiKeys).map((key) => (
                <option value={key.secret}>{key.secret}</option>
            ))}
        </select>
    )
}
export default SelectAPIKey;